<template>
  <td :class="positionClass(palletOrder)" style="vertical-align: top; text-align: left;">
    {{ number }}
    <br/>
    <div v-if="!half">
      <v-tooltip top open-delay="500">
        <template v-slot:activator="{ on }">
          <div v-if="hasPallet" :class="palletClass(palletOrder)" v-on="on">
            <PalletItems v-if="palletOrder.items" :items="palletOrder.items"/>
          </div>
        </template>
        <span><div v-html="palletTitle(palletOrder)"></div></span>
      </v-tooltip>
    </div>
    <div v-if="half">
      <v-tooltip top open-delay="500">
        <template v-slot:activator="{ on }">
          <div v-if="hasPallet" :class="palletClass(palletOrder)" v-on="on">
            <PalletItems v-if="palletOrder.items" :items="palletOrder.items"/>
          </div>
        </template>
        <span><div v-html="palletTitle(palletOrder)"></div></span>
      </v-tooltip>
      <v-tooltip top open-delay="500">
        <template v-slot:activator="{ on }">
          <div style="margin-top: 5px;" v-if="hasPalletSecondRow" :class="palletClass(palletOrderSecondRow)" v-on="on">
            <PalletItems v-if="palletOrderSecondRow.items" :items="palletOrderSecondRow.items"/>
          </div>
        </template>
        <span><div v-html="palletTitle(palletOrderSecondRow)"></div></span>
      </v-tooltip>
    </div>
  </td>
</template>

<script>
import PalletItems from '../components/PalletItems'

export default {
  name: 'ShipmentPalletOrder',
  components: { PalletItems },
  props: {
    value: Object,
    number: String,
    positions: Array
  },
  created: function () {
  },
  data () {
    return {
    }
  },
  methods: {
    palletClass: function (palletOrder) {
      return 'shipmentPallet' + (palletOrder ? ' deliveryZone_' + palletOrder.deliveryZone : '')
    },
    positionClass: function (palletOrder) {
      return 'shipmentPallet'
    },
    palletTitle: function (palletOrder) {
      let palletTitle = '<table>'
      palletTitle += '<tr><td>Supplier:</td><td>' + (palletOrder.supplier && palletOrder.supplier.name ? palletOrder.supplier.name : '') + '</td></tr>'
      palletTitle += '<tr><td>Field:</td><td>' + (palletOrder.field && palletOrder.field.address && palletOrder.field.address ? palletOrder.field.address.nameAndText : '') + '</td></tr>'
      palletTitle += '<tr><td>Contractor:</td><td>' + (palletOrder.contractor && palletOrder.contractor.name ? palletOrder.contractor.name : '') + '</td></tr>'
      palletTitle += '<tr><td style="padding-right: 5px;">Loading address:</td><td>' + (palletOrder.pickupAddress && palletOrder.pickupAddress.nameAndText ? palletOrder.pickupAddress.nameAndText : '') + '</td></tr>'
      if (palletOrder.internalCarrier && palletOrder.internalCarrier.name) {
        palletTitle += '<tr><td>Internal carrier:</td><td>' + (palletOrder.internalCarrier && palletOrder.internalCarrier.name ? palletOrder.internalCarrier.name : '</td></tr>')
      }
      palletTitle += '</table>'
      return palletTitle
    }
  },
  computed: {
    palletOrder: function () {
      let index = Number(this.number) - 1
      return this.positions[index] ? this.positions[index] : null
    },
    palletOrderSecondRow: function () {
      let index = Number(this.number) + 10 - 1
      return this.positions[index] ? this.positions[index] : null
    },
    half: function () {
      return (this.palletOrderSecondRow && this.palletOrderSecondRow.id) || (this.palletOrder && this.palletOrder.half)
    },
    hasPallet: function () {
      return this.palletOrder && this.palletOrder.id > 0
    },
    hasPalletSecondRow: function () {
      return this.palletOrderSecondRow && this.palletOrderSecondRow.id > 0
    }
  }
}
</script>

<style scoped>
  div.shipmentPallet {
    padding: 5px;
    border: 1px solid #bbbbbb;
    border-radius: 4px;
    min-height: 50px;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/ShipmentPalletOrder.vue